import { Modal } from 'antd';
import { useEffect, useRef, useState } from 'react';
import FactorySearcher from './Factory';
import SupplierSearcher from './Supplier';
import { isEmpty, isEqual, isNil } from 'lodash';

enum SearcherType {
  suppliers = 'suppliers',
  factories = 'factories',
  products = 'products'
}

type Value = {
  [field: string]: any;
};

type SearcherProps = {
  type: keyof typeof SearcherType;
  open?: boolean;
  title?: string;
  multiple?: boolean;
  selected: Value[];
  otherSource?: Value[];
  onCancel: () => void;
  onOk: (selectedItems: Value[]) => void;
  onBindingValue?: (value: Value) => Value;
};

const SEARCHER = {
  [SearcherType.suppliers]: SupplierSearcher,
  [SearcherType.factories]: FactorySearcher
};

export function Searcher(props: SearcherProps) {
  const {
    open,
    title,
    multiple,
    type,
    onCancel,
    onOk,
    onBindingValue,
    selected = [],
    otherSource = []
  } = props;

  const latestSelected = useRef<any | null>(null);
  const [selectedItem, setSelectedItem] = useState(selected);

  const SearcherComponent = SEARCHER[type];
  if (SearcherComponent === undefined) {
    throw Error(`Searcher type ${type.toString()} is not supported`);
  }

  const handleOnCancel = () => {
    onCancel();
    setTimeout(() => {
      setSelectedItem(latestSelected.current);
    });
  };
  useEffect(() => {
    if (isNil(selected) || isEmpty(selected)) {
      setSelectedItem([]);
    }
    if (!isEqual(selected, latestSelected)) {
      latestSelected.current = selected;
      setSelectedItem(selected);
    }
  }, [selected]);
  return (
    <Modal
      open={open}
      title={title}
      okText="Confirm"
      onOk={() => {
        onOk(selectedItem);
      }}
      onCancel={handleOnCancel}
      cancelButtonProps={{
        hidden: true
      }}
    >
      <SearcherComponent
        multiple={multiple}
        otherSource={otherSource}
        selected={selectedItem}
        onBindingValue={onBindingValue}
        onChange={(selectedItems) => {
          setSelectedItem(selectedItems);
        }}
      ></SearcherComponent>
    </Modal>
  );
}
